<template>
  <div class="patients">
    <breadcrumbs :items="breadcrumbs">
      <div class="breadcrumbs-actions">
        <rp-sprite @click.native="exportPatients" class="create-icon" name="get_app" />
      </div>
    </breadcrumbs>

    <rp-table
      name="patients"
      :results="getPatients"
      :headings="['name', 'email', 'gender', {heading: 'Year of birth', key: 'yob'}, {heading: 'Actions', key: 'schedule-surgery'}]"
      @rowClick="onRowClick">

      <rp-button
        class="btn primary" 
        @click.stop="scheduleSurgery(patient)"
        v-for="(patient, index) in patients"
        :key="index"
        :slot="'td-' + index + '-schedule-surgery'">
        add surgery
      </rp-button>
    </rp-table>
  </div>
</template>

<script>
import Table from 'raypro_ui/src/components/ui/Table'
import Sprite from 'raypro_ui/src/components/ui/Sprite'
import Breadcrumbs from '@/components/Breadcrumbs'
import Button from 'raypro_ui/src/components/ui/inputs/Button'

import page from '@/mixins/page'

// API
import {getPatients} from 'raypro_ui/src/api/users'
import {exportPatients} from 'raypro_ui/src/api/csvs'

export default {
  mixins: [page],

  components: {
    'rp-table': Table,
    'rp-sprite': Sprite,
    'rp-button': Button,
    Breadcrumbs
  },

  data() {
    return {
      patients: [],
      page: {
        totalPages: 1,
        totalEntries: 0,
        pageSize: 10,
        pageNumber: 1
      },
      breadcrumbs: [
        {label: 'All Patients'}
      ],
      title: 'All Patients'
    }
  },

  methods: {
    onRowClick(row) {
      this.$router.push(`/patients/${row.id}`)
    },

    getPatients(page) {
      return getPatients(page).then(({data, page}) => {
        const mapped = data.map((row) => {
          return {
            id: row.id,
            // name: `${row.profile.first_name} ${row.profile.last_name}`,
            name: this.getFullName(row),
            email: row.email,
            // TODO: map to age group
            yob: row.profile.yob,
            gender: row.profile.gender
          }
        })

        this.patients = mapped

        return {
          data: mapped,
          page
        }
      })
    },

    scheduleSurgery(patient) {
      this.$router.push({name: 'add-patients', params: {patientEmail: patient.email}})
    },

    exportPatients() {
      exportPatients().then((res) => {
        const disposition = res.headers['content-disposition']
        const matches = /"([^"]*)"/.exec(disposition)
        const filename = matches !== null && matches[1] ? matches[1] : 'file.csv'
        const blob = new Blob([res.data], {type: 'text/csv'})
        const link = document.createElement('a')

        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    getFullName(data) {
      const profile = data.profile
      let name = ''

      if(profile) {
        if(!profile.first_name && !profile.last_name) {
          return 'NOT PROVIDED'
        }
        if(profile.first_name) {
          name += `${profile.first_name}`
        }
        if(profile.last_name) {
          name += ` ${profile.last_name}`
        }
        return name
      }
      return 'PATIENT DELETED'
    },
  }
}
</script>

<style lang="sass" scoped>
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.btn
  margin: 0

.patients
  .table
    /* TODO: no... */
    box-shadow: $color-shadow

    tr
      cursor: pointer

    .table-header, .table-row
      border-bottom: 1px solid $color-grey-light
</style>



// WEBPACK FOOTER //
// src/components/pages/Patients/Patients.vue